import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { admin } = useAuth();
  if (admin === null)
    return <div className="min-h-screen flex items-center justify-center text-muted-foreground font-mono-tech">Caricamento…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
};
